"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleUpdatedPlayableClips;

var _getTotalClipsDuration = _interopRequireDefault(require("./getTotalClipsDuration"));

var _getCurrentClipFromTime = require("./clips/getCurrentClipFromTime");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function handleUpdatedPlayableClips(playableClips, newPlayableClips) {
  return function (_ref) {
    var currentClip = _ref.currentClip,
        currentTime = _ref.currentTime;
    var newClipIndex = currentClip ? (0, _getCurrentClipFromTime.getCurrentClipIndexFromTime)(currentTime, newPlayableClips) : 0;
    var newClip = newPlayableClips[newClipIndex];
    var elapsedDuration = (0, _getTotalClipsDuration.default)(newPlayableClips.slice(0, newClipIndex));
    return {
      totalDuration: (0, _getTotalClipsDuration.default)(newPlayableClips),
      currentClip: newClip,
      buffering: Boolean(!playableClips.length && newPlayableClips.length),
      elapsedDuration: elapsedDuration,
      playableClips: newPlayableClips,
      currentTime: !newPlayableClips.length ? 0 : currentTime
    };
  };
}